export default __webpack_public_path__ + "08baff06d5125be08c708085b97b88f1.png";